import {
  Checkbox,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { useCallback, useState } from "react";
import type { UseFormReturn } from "react-hook-form";

import type { ForkSchema } from "./schema";

interface ForkAliasProps {
  form: UseFormReturn<ForkSchema>;
}

const ForkAlias: FC<ForkAliasProps> = ({ form }) => {
  const { control, setValue, getValues } = form;
  const [pin, setPin] = useState(!!getValues("alias"));

  const togglePin = useCallback(
    (value: boolean) => {
      if (value === false) {
        setValue("alias", undefined);
      }
      setPin(value);
    },
    [setValue],
  );

  return (
    <>
      <FormItem className="flex flex-row items-start space-x-2 space-y-0 py-2">
        <FormControl>
          <Checkbox checked={pin} onCheckedChange={togglePin} />
        </FormControl>
        <div className="leading-none">
          <FormLabel>📌 Pin this fork</FormLabel>
        </div>
      </FormItem>

      {!!pin && (
        <FormField
          control={control}
          name="alias"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Alias</FormLabel>
              <FormControl>
                <Input
                  placeholder="fork alias"
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormDescription>Alias used for pinned fork</FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};

export default ForkAlias;
